// @flow

import { STATUS_DEFAULT, STATUS_LOADING, STATUS_FAILURE, STATUS_SUCCESS } from 'constants/statusConstants';
import {
  FETCH_YOUTUBE_LIVE_START,
  FETCH_YOUTUBE_LIVE_SUCCESS,
  FETCH_YOUTUBE_LIVE_FAILURE
} from 'actions/ffr-tv/youtubeLiveActions';

import { nullYoutubeVideo, type YoutubeVideo } from 'types/YoutubeVideo';
import type { Status } from 'types/Status';
import type { ActionType } from 'types/Actions';

export type State = {
  video: ?YoutubeVideo,
  status: Status
};

const initialState: State = {
  video: nullYoutubeVideo,
  status: STATUS_DEFAULT
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_YOUTUBE_LIVE_START:
      return {
        ...state,
        status: STATUS_LOADING
      };
    case FETCH_YOUTUBE_LIVE_SUCCESS:
      return {
        ...state,
        video: action.payload.video,
        status: STATUS_SUCCESS
      };
    case FETCH_YOUTUBE_LIVE_FAILURE:
      return {
        ...state,
        status: STATUS_FAILURE
      };
    default:
      return state;
  }
}
